import "./Announcement.scss";
import {
  Card,
  Layout,
  Button,
  notification,
  Skeleton,
  Col,
  Row,
  Empty,
  Space,
  Table,
  Flex,
  Modal,
  Typography,
} from "antd";
import React, { useEffect, useState } from "react";
import type { TableProps } from "antd";
import {
  CheckCircleFilled,
  DeleteOutlined,
  FormOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import Search from "antd/es/input/Search";
import { useSelector } from "react-redux";
import {
  AnnouncementMessages,
  AnnouncementRaw,
  EventtMessages,
  GroupsMessages,
  PageSetting,
  Query,
  SearcherMessages,
  SearcherRaw,
  SortMode,
} from "../../..";
import MenuBar from "../../../components/Menu/MenuBar";
import Footer from "../../../components/Footer/Footer";
import store from "../../../../controllers/store";
import { find } from "../../../../controllers/store/actions/announcement/get-announcements-actions";
import {
  findById,
  update,
} from "../../../../controllers/store/actions/announcement/update-announcement-actions";
import { remove } from "../../../../controllers/store/actions/announcement/delete-announcement-action";
import { clear } from "../../../../controllers/store/actions/announcement/create-announcement-action";
import NewAnnouncementrModal from "../../../components/Forms/Modal/Announcements/NewAnnouncement";
import UpdateAnnouncementModal from "../../../components/Forms/Modal/Announcements/UpdateAnnouncement";

const { confirm } = Modal;
const { Header, Content } = Layout;
const { Paragraph, Text } = Typography;
const dispatch = store.dispatch;
const formatter = new Intl.NumberFormat("es-ES", {
  style: "currency",
  currency: "COP", // Cambia a 'USD', 'COP', etc., según la moneda que necesites.
});
const query: Query = { filter: {} };
const Announcement: React.FC = () => {
  const [visibleCreateModal, setVisibleCreateModal] = useState(false);
  const [visibleUpdateModal, setVisibleUpdateModal] = useState(false);
  const [page, setPage] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(PageSetting.limit);
  const [api, contextHolder] = notification.useNotification();
  const announcementsState = useSelector((state: any) => state.announcements);
  const updatedAnnouncementState = useSelector(
    (state: any) => state.updatedAnnouncement
  );
  const deletedAnnouncementState = useSelector(
    (state: any) => state.deletedAnnouncement
  );
  const createdAnnouncementState = useSelector(
    (state: any) => state.createdAnnouncement
  );
  const userState = useSelector((state: any) => state.user.user);

  const columns: TableProps<AnnouncementRaw>["columns"] = [
    {
      title: "Nombre de la convocatoria",
      dataIndex: "nombre",
      key: "nombre",
    },
    {
      title: "Descripción breve del proyecto",
      dataIndex: "descripcion_breve",
      key: "descripcion_breve",
    },
    {
      title: "Responsable",
      dataIndex: "responsable",
      key: "responsable",
    },
    {
      title: "Institucion",
      dataIndex: "institucion",
      key: "institución",
    },
    /*{
      title: "Tecnologias",
      dataIndex: "tecnologias",
      key: "tecnologias",
    },
    {
      title: "Presupuesto",
      dataIndex: "presupuesto",
      key: "Presupuesto",
      render(value, record, index) {
        return <Text>{formatter.format(value)}</Text>;
      },
    },
    {
      title: "Solución de la propuesta",
      dataIndex: "solucion",
      key: "solucion",
      render: (text, record, index) => {
        return (
          <Paragraph
            ellipsis={{
              rows: 2,
              expandable: true,
              symbol: "Más",
              tooltip: text,
            }}
          >
            {text}
          </Paragraph>
        );
      },
    },
    {
      title: "Tipo de organización (Solucionador)",
      dataIndex: "tipo_organizacion",
      key: "tipo_organizacion",
    },
    {
      title: "Expectativas de la solución",
      dataIndex: "expectativas_solucion",
      key: "expectativas_solucion",
      render: (text, record, index) => {
        return (
          <Paragraph
            ellipsis={{
              rows: 2,
              expandable: true,
              symbol: "Más",
              tooltip: text,
            }}
          >
            {text}
          </Paragraph>
        );
      },
    },*/
    {
      title: "Fecha de inicio de visibilidad",
      dataIndex: "visibility_start_date",
      key: "visibility_start_date",
    },
    {
      title: "Fecha de finalización de visibilidad",
      dataIndex: "visibility_end_date",
      key: "visibility_end_date",
    },
    {
      title: "Fecha de creación",
      dataIndex: "created_at",
      key: "created_at",
    },
    {
      title: "Última actualización",
      dataIndex: "updated_at",
      key: "updated_at",
    },
    {
      title: "Acciones",
      key: "action",
      fixed: "right",
      width: 250,
      render: (_, record: AnnouncementRaw) => (
        <Space size="middle">
          <Button
            type="primary"
            onClick={() => {
              if (record.id) {
                dispatch(findById(record.id));
              }
              setVisibleUpdateModal(!visibleUpdateModal);
            }}
            size="small"
            icon={<FormOutlined />}
          >
            Modificar
          </Button>
          <Button
            type="primary"
            onClick={() => {
              if (record && record.id) {
                confirm({
                  okType: "primary",
                  okText: "Publicar",
                  cancelText: "Cancelar",
                  title: EventtMessages.Title,
                  content: EventtMessages.EventPublished,
                  onOk: async () => {
                    if (record.id) {
                      try {
                        await dispatch(
                          update(record.id, {
                            status:
                              record.status === "Published"
                                ? "Draft"
                                : "Published",
                          })
                        );
                        query.filter.user = `&filter[user_created][_eq]=${userState.me.id}&deep=true&sort=-created_at`;
                        dispatch(find(page || 1, pageSize, query));
                      } catch (error) {
                        console.error(
                          "Error al actualizar el convocatoria",
                          error
                        );
                      }
                    }
                  },
                  onCancel() {},
                });
              }
            }}
            size="small"
            icon={
              record.status === "Published" ? (
                <DeleteOutlined />
              ) : (
                <CheckCircleFilled twoToneColor={"#28A745"} color="#28A745" />
              )
            }
          >
            {record.status === "Published" ? "Quitar publicación" : "Publicar"}
          </Button>
          <Button
            type="default"
            onClick={() => {
              confirm({
                okType: "primary",
                okText: "Borrar",
                cancelText: "Cancelar",
                title: AnnouncementMessages.Title,
                content: AnnouncementMessages.AnnouncementsConfirmDeleteMessage,
                onOk: async () => {
                  if (record.id) {
                    await dispatch(remove(record.id));
                    dispatch(find(page, pageSize, query));
                  }
                },
                onCancel() {},
              });
            }}
            size="small"
            icon={<DeleteOutlined />}
          >
            Eliminar
          </Button>
        </Space>
      ),
    },
  ];

  const showCreatedAnnouncementMessageSuccess = () => {
    api["success"]({
      key: 1,
      message: AnnouncementMessages.Title,
      description: AnnouncementMessages.AnnouncementCreated,
    });
    dispatch(clear());
    return null;
  };

  const showDeletedAnnouncementMessage = () => {
    api["success"]({
      key: 1,
      message: AnnouncementMessages.Title,
      description: AnnouncementMessages.AnnouncementsDeleteSuccessMessage,
    });

    dispatch(clear());
    return null;
  };

  const showUpdatedAnnouncementMessage = () => {
    api["success"]({
      key: 1,
      message: AnnouncementMessages.Title,
      description: AnnouncementMessages.AnnouncementUpdateSuccessMessage,
    });

    dispatch(clear());
    return null;
  };

  useEffect(() => {
    query.filter.user = `&filter[user_created][_eq]=${userState.me.id}&deep=true`;
    dispatch(find(1, pageSize, query));
  }, [pageSize]);

  return (
    <Layout className="announcement-layout">
      {contextHolder}
      {createdAnnouncementState.createdSearcher
        ? showCreatedAnnouncementMessageSuccess()
        : null}
      {deletedAnnouncementState.removed
        ? showDeletedAnnouncementMessage()
        : null}
      {updatedAnnouncementState.updatedSearcher
        ? showUpdatedAnnouncementMessage()
        : null}
      <MenuBar />
      <Header className="bg-header-profile" />
      <Content className="announcement-content">
        <Card className="announcement-card">
          <NewAnnouncementrModal
            visible={visibleCreateModal}
            onCreated={() => {
              setVisibleCreateModal(false);
              dispatch(find(page, pageSize, query));
            }}
            onCancel={() => {
              setVisibleCreateModal(false);
            }}
          />
          <UpdateAnnouncementModal
            announcement={updatedAnnouncementState.announcement}
            visible={visibleUpdateModal}
            onUpdated={() => {
              setVisibleUpdateModal(false);
              dispatch(find(page, pageSize, query));
            }}
            onCancel={() => {
              setVisibleUpdateModal(false);
            }}
          />
          <Skeleton
            loading={announcementsState.isLoading}
            active
            className="full-width"
          >
            {announcementsState?.list?.length === 0 ? (
              <>
                <br />
                <br />
                <br />
                <br />
                <Empty
                  image="https://gw.alipayobjects.com/zos/antfincdn/ZHrcdLPrvN/empty.svg"
                  imageStyle={{ height: 60 }}
                  description={<span>No tienes convocatorias aún</span>}
                >
                  <Button
                    icon={<PlusOutlined />}
                    onClick={() => {
                      setVisibleCreateModal(!visibleCreateModal);
                    }}
                    type="primary"
                  >
                    Agregar convocatoria
                  </Button>
                </Empty>
                <br />
                <br />
                <br />
                <br />
              </>
            ) : (
              <>
                <h1 className="heading-content-title">Convocatorias</h1>
                <Row
                  gutter={[8, 8]}
                  style={{ width: "100%", marginBottom: 20 }}
                >
                  <Col xs={24} sm={12} md={8} lg={12}>
                    <Flex vertical={true} align={"flex-start"}>
                      <Search
                        placeholder="Buscar"
                        onSearch={(value: string) => {
                          if (value) {
                            query.filter.text = `&filter[nombre][_contains]=${value}`;
                            query.meta = `filter_count`;
                            query.sort = [
                              { field: "created_at", mode: SortMode.DES },
                            ];
                            return dispatch(find(1, pageSize, query));
                          }

                          dispatch(find(1, PageSetting.limit, {} as Query));
                        }}
                        enterButton
                      />
                    </Flex>
                  </Col>
                  <Col xs={24} sm={12} md={8} lg={12}>
                    <Flex vertical={true} align={"flex-end"}>
                      <Button
                        type="primary"
                        onClick={() =>
                          setVisibleCreateModal(!visibleCreateModal)
                        }
                        size="middle"
                        icon={<PlusOutlined />}
                      >
                        Agregar convocatoria
                      </Button>
                    </Flex>
                  </Col>
                </Row>
                <Table
                  scroll={{ x: 1200 }}
                  pagination={{
                    locale: {
                      jump_to: "Ir a",
                      items_per_page: "Items por pagina",
                    },
                    total:
                      announcementsState?.meta?.total_count ||
                      announcementsState.meta.filter_count,
                    current: page,
                    pageSize: PageSetting.limit,
                    onChange: (page) => {
                      dispatch(find(page, pageSize, query));
                      setPage(page);
                    },
                    onShowSizeChange: (pageSize) => {
                      dispatch(find(page, pageSize, query));
                      setPageSize(pageSize);
                    },
                  }}
                  locale={{ emptyText: "Sin Resultados." }}
                  columns={columns}
                  dataSource={announcementsState.list}
                />
              </>
            )}
          </Skeleton>
        </Card>
      </Content>
      <Footer />
    </Layout>
  );
};

export default Announcement;
